import { cva, VariantProps } from 'class-variance-authority'

export { default as StatusChip } from './StatusChip.vue'

export const statusChipVariants = {
  size: {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-md',
    lg: 'text-lg',
  },
  rounded: {
    xs: 'rounded-sm',
    sm: 'rounded',
    md: 'rounded-md',
    lg: 'rounded-lg',
  },
  variant: {
    info: 'text-neutral-dark-0 bg-neutral-light-5',
    success: 'text-success-3 bg-success-9',
    error: 'text-error-3 bg-error-9',
  },
} as const

export const statusChipCva = cva(
  'px-3 py-1 inline-flex gap-2 items-center font-bold whitespace-nowrap',
  {
    variants: statusChipVariants,
    defaultVariants: {
      variant: 'info',
      rounded: 'sm',
      size: 'sm',
    },
  },
)
export type StatusChipProps = VariantProps<typeof statusChipCva>
